import React from "react";
import axios from "axios";
import { Icon, Spin, Divider, Row, Col, Button } from "antd";
import moment from "moment";
import InfiniteScroll from "react-infinite-scroller";
// import $ from "jquery";

class NotificationScroll extends React.Component {
  state = {
    popupClosedOnce: false,
    notifications: [],
    hasMoreNotification: false,
    firstLoad: true,
  };

  componentDidMount() {
    axios.get("/api/notification_seen");
    this.getNotifications(0, 11, true);
  }

  // getNotifications = (start, size, isfirstLoad = false) => {
  //   if (isfirstLoad) {
  //     this.setState({ firstLoad: isfirstLoad });
  //   }

  //   if (this.props.hideNotificationPopup) {
  //     this.props.hideNotificationPopup();
  //   }


  //   axios
  //     .get("/api/get_notification", { params: { start, size } })
  //     .then((res) => {
  //       const notifications = res.data.message;

  //       if (notifications.length > 10) {
  //         notifications.pop();
  //         this.setState((prevState) => ({
  //           firstLoad: false,
  //           hasMoreNotification: true,
  //           notifications: [...prevState.notifications, ...notifications],
  //         }));
  //       } else {
  //         this.setState((prevState) => ({
  //           firstLoad: false,
  //           hasMoreNotification: false,
  //           notifications: [...prevState.notifications, ...notifications],
  //         }));
  //       }
  //     });
  // };

  getNotifications = (start, size, isfirstLoad = false) => {
    if (isfirstLoad) {
      this.setState({ firstLoad: true });
    }

    if (
      this.props.hideNotificationPopup &&
      !this.state.popupClosedOnce
    ) {
      this.props.hideNotificationPopup();
      this.setState({ popupClosedOnce: true });
    }

    axios
      .get("/api/get_notification", { params: { start, size } })
      .then((res) => {
        const notifications = res.data.message;

        if (notifications.length > 10) {
          notifications.pop();
          this.setState((prevState) => ({
            firstLoad: false,
            hasMoreNotification: true,
            notifications: [...prevState.notifications, ...notifications],
          }));
        } else {
          this.setState((prevState) => ({
            firstLoad: false,
            hasMoreNotification: false,
            notifications: [...prevState.notifications, ...notifications],
          }));
        }
      });
  };


  handleLoadMore = (page) => {
    const start = (page - 1) * 10;
    this.getNotifications(start, 11);
  };

  RedirectToBfile = (data) => {
    if (data.notification.bfile) {
      this.props.history.push(`/customer/${data.notification.bfile}`);
    }
    this.props.toggleNotification();
  };

  getClickableNameLink = (notify) => {
    if (notify.notification.bfile) {
      const name = notify.notification.notification_message
        .split("The phone number for ")[1]
        .split(" is not valid. Please update it.")[0];
      const mewMessage = notify.notification.notification_message.replace(
        name,
        "###"
      );
      const [message_1, message_2] = mewMessage.split("###");
      const linkName = (
        <p>
          {" "}
          {message_1}{" "}
          <Button type="link" onClick={() => this.RedirectToBfile(notify)}>
            {" "}
            {name}
          </Button>{" "}
          {message_2}
        </p>
      );
      return linkName;
    } else {
      return <p>{notify.notification.notification_message}</p>;
    }
  };

  RedirectToLockedUser = (data) => {

    this.props.history.push(`/manage-users/locked-users`);
    this.props.toggleNotification();
  };


  routeToLockedUser = (notify) => {
    const [
      message_1,
      name,
      message_2,
    ] = notify.notification.notification_message.split("###");

    const linkName = (
      <p>
        {" "}
        {message_1}{" "}
        <Button type="link" onClick={() => this.RedirectToLockedUser(notify)}>
          {" "}
          {name}
        </Button>{" "}
        {message_2}
      </p>
    );
    return linkName;
  }

  getClickableNameLinkV2 = (notify) => {
    if (!notify.notification.bfile) {
      return this.routeToLockedUser(notify);
    }
    const [
      message_1,
      name,
      message_2,
    ] = notify.notification.notification_message.split("###");
    if (!name) {
      return <p>{notify.notification.notification_message}</p>;
    }
    const linkName = (
      <p>
        {" "}
        {message_1}{" "}
        <Button type="link" onClick={() => this.RedirectToBfile(notify)}>
          {" "}
          {name}
        </Button>{" "}
        {message_2}
      </p>
    );
    return linkName;
  };

  render() {
    return (
      <div className="dropdown-content notification_dropdown" id="myDropdown" style={{ padding: 15 }}>
        <div className="text-align">
          <div>
            <h3>Notifications</h3>
          </div>
        </div>

        <InfiniteScroll
          pageStart={1}
          loader={<Spin />}
          hasMore={this.state.hasMoreNotification}
          loadMore={(page) => this.handleLoadMore(page)}
          useWindow={false}
        >
          <div className="borders">
            {this.state.firstLoad && <Spin key={0} />}

            {this.state.notifications.length === 0 && !this.state.firstLoad && (
              <h2>No Notification</h2>
            )}

            {this.state.notifications.map((notify, i) => {
              return (
                <Row key={`${i}`}>
                  <div className="media-body">
                    <Col md={20}>
                      {this.getClickableNameLinkV2(notify)}
                      <p>
                        {moment
                          .unix(notify.notification.dispatch_time)
                          .format("MM-DD-YYYY HH:mm")}
                      </p>
                    </Col>
                    <Col className="deleteColumn" md={4}>
                      <Row>
                        <Col md={24}>
                          <Icon
                            onClick={(e) => {
                              window.toggle = false;
                              this.props.deleteNotification(notify.id);
                            }}
                            width="10"
                            type="delete"
                            style={{ fontSize: "18px" }}
                            class="dropbtn"
                          />
                        </Col>
                      </Row>
                    </Col>
                    <Divider />
                  </div>
                </Row>
              );
            })}
          </div>
        </InfiniteScroll>
      </div>
    );
  }
}

export default NotificationScroll;



// WEBPACK FOOTER //
// ./src/components/notificationScroll.js